<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between">
        <h2>{{ SelectProduct.title }}</h2>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="primary"
              v-on="on"
              @click="$router.push({ name: 'catalogue_products' })"
            >
              <v-icon style="font-size: 6vh">mdi-arrow-left-box</v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>

      <v-col cols="12" sm="6" md="7" lg="7">
        <v-card color="transparent" flat>
          <v-card-text class="px-0 py-0">
            <v-timeline dense>
              <v-timeline-item>
                <v-card class="elevation-2">
                  <v-card-title class="font-size-timelines"
                    >Disponibilidad</v-card-title
                  >

                  <v-card-text>
                    <span>
                      Disponibilidad en el Stock:
                      <span :class="textColor(SelectProduct.stock_text)">{{
                        SelectProduct.stock_text
                      }}</span>
                    </span>
                    <v-spacer></v-spacer>
                    <span>
                      Próximo Ingreso:
                      <span class="font-weight-bold">{{
                        SelectProduct.available_date | dateStart
                      }}</span>
                    </span>
                    <v-row class="mt-8">
                      <v-col class="pr-4">
                        <v-slider
                          v-if="SelectProduct.discount_step_b2b"
                          v-model="slider_product"
                          :tick-labels="
                            SliderLabels(SelectProduct.discount_step_b2b)
                          "
                          min="0"
                          :max="SelectProduct.discount_step_b2b.length"
                          ticks="always"
                          thumb-label="always"
                          tick-size="4"
                        >
                          <template v-slot:thumb-label="props">{{
                            season(props.value, SelectProduct.discount_step_b2b)
                          }}</template>
                        </v-slider>
                        <v-spacer class="mt-4"></v-spacer>
                        <span>
                          Compra minima:
                          <span class="font-weight-bold"
                            >{{ SelectProduct.step_b2b }} unidades</span
                          >
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <v-timeline-item>
                <v-card class="elevation-2">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                        <div class="d-flex justify-space-between">
                          <div>
                            <v-card-title
                              class="font-size-timelines py-0 black--text px-0"
                              >Precio</v-card-title
                            >

                            <v-spacer class="my-6"></v-spacer>

                            <span>
                              Comprando
                              <span class="font-weight-bold">{{
                                Quantity(SelectProduct.discount_step_b2b)
                              }}</span>
                              Unidades obtienes un descuento de
                              <span class="font-weight-bold h3-price"
                                >{{
                                  Discount(SelectProduct.discount_step_b2b)
                                }}
                                %</span
                              >
                            </span>
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="12" md="5" lg="5" class="pt-0">
                        <span>
                          <span class="font-weight-bold"
                            >Precio Comercio Neto Unitario</span
                          >
                        </span>
                        <v-spacer class="mb-5"></v-spacer>
                        <span class="h3-price black--text">
                          {{
                            PVC(
                              SelectProduct.pvc,
                              SelectProduct.discount_step_b2b
                            ) | currency
                          }}
                          <span style="font-size: 13px"
                            >+ IVA {{ SelectProduct.iva }} %</span
                          >
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="7"
                        lg="2"
                        class="pt-0 mx-auto"
                      >
                        <span class="font-weight-bold">Mark UP</span>
                        <v-spacer class="mb-5"></v-spacer>
                        <span class="h3-price black--text"
                          >{{ MUP(SelectProduct) }} %</span
                        >
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="5"
                        lg="4"
                        class="pt-0 pl-5 pr-0"
                      >
                        <span>
                          <span class="font-weight-bold">Precio Publico</span>
                        </span>
                        <v-spacer class="mb-5"></v-spacer>
                        <span class="h3-price black--text">{{
                          SelectProduct.pvp | currency
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <v-timeline-item>
                <v-card class="elevation-2">
                  <v-card-title class="font-size-timelines"
                    >Caracteristicas</v-card-title
                  >
                  <v-card-text
                    v-html="convertHTMLEntity(SelectProduct.description)"
                  ></v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="5" lg="5">
        <v-card class="mt-6">
          <v-card-text>
            <v-img
              v-if="render2 == false"
              :lazy-src="image_url"
              :aspect-ratio="1"
              class="grey lighten-2"
              :src="image_url"
              style="border-radius: 5px; box-sizing: inherit"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <img
              style="max-width: 100%"
              v-if="render2"
              :lazy-src="image_url"
              class="grey lighten-2"
              :src="image_url"
            />
            <v-row v-if="render">
              <v-col
                v-for="(image, i) in images"
                :key="i"
                class="d-flex child-flex"
                cols="3"
              >
                <v-card @click="img(image)">
                  <v-img
                    :src="image"
                    :lazy-src="image"
                    aspect-ratio="1"
                    class="grey lighten-2 img-fluid"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      render2: false,
      render: false,
      min: 0,
      max: 10,
      slider_product: 0,
      ticksLabels: [0, 1, 2],
      index: null,
      image_url: "",
      fruits: 0,
    };
  },

  created() {
    this.getSelectProduct();
    this.render = true;
  },

  filters: {
    dateStart(value) {
      return moment(value)
        .locale("es")
        .format("DD/MM/YYYY");
    },
  },

  computed: {
    SelectProduct() {
      return this.$store.getters["product/GET_SELECTED_PRODUCT"];
    },

    images() {
      if (this.SelectProduct.pictures) {
        return this.SelectProduct.pictures;
      }
      return [];
    },

    itemsDiscount() {
      return this.$store.getters["auth/DISCOUNT_CLIENT"];
    },
  },

  methods: {
    textColor(item) {
      if (item == "disponibilidad alta") {
        return "font-text-12  bg-green text-capitalize";
      } else if (item == "disponibilidad media") {
        return "font-text-12  bg-yellow text-capitalize";
      } else if (item == "disponibilidad baja") {
        return "font-text-12 bg-blue text-capitalize";
      } else if (item == "No Disponible") {
        return "font-text-12  bg-red text-capitalize";
      } else {
        return "font-text-12 bg-pink";
      }
    },

    Quantity(discount) {
      if (this.slider_product > 0) {
        return discount[this.slider_product - 1].quantity;
      } else {
        return 0;
      }
    },

    season(val, discount_step_b2b) {
      let discount = this.SliderLabels(discount_step_b2b);
      return discount[val];
    },

    async getSelectProduct() {
      try {
        const response = await this.$store.dispatch("product/SELECT_PRODUCT", {
          id: this.$route.params.id,
        });

        this.render2 = true;
        this.image_url = response.pictures[0];
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      }
    },

    PVC(pvc, discount) {
      let pvc_total_product = 0;
      let pvc_total = 0;
      if (this.slider_product > 0) {
        let data_product = discount[this.slider_product - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        pvc_total_product = pvc - (pvc * discount_product) / 100;

        pvc_total =
          pvc_total_product - pvc_total_product * (this.itemsDiscount / 100);
      } else {
        pvc_total = pvc - pvc * (this.itemsDiscount / 100);
      }
      return pvc_total;
    },
    // PVP(pvp) {
    //   pvp = pvp === null ? 0 : pvp;
    //   return pvp * this.slider_product;
    // },

    // PVP(pvp, pvp_without_iva) {
    //   return pvp == null ? 0 : pvp * (pvp_without_iva/100);
    // },

    MUP(item) {
      let MUP = 0;

      let pvc_discount = this.PVC(item.pvc, item.discount_step_b2b);

      if (item.pvp_without_iva > 0 && pvc_discount > 0) {
        // MUP =
        //   ((item.pvp_without_iva - pvc_discount) / item.pvp_without_iva) * 100;

        MUP = (item.pvp_without_iva / pvc_discount - 1) * 100;
      }
      return MUP.toFixed(2);
    },

    img(image) {
      this.image_url = image;
    },

    convertHTMLEntity(text) {
      const span = document.createElement("span");
      if (text) {
        return text.replace(/&[#A-Za-z0-9]+;/gi, (entity) => {
          span.innerHTML = entity;
          return span.innerText;
        });
      }
    },

    SliderLabels(discount) {
      let data;
      if (discount.length > 0) {
        data = discount.map((index) => {
          return index.quantity;
        });

        data.splice(0, 0, 0);
      } else {
        data = [0];
      }

      return data;
    },

    Discount(discount) {
      let data = 0;
      if (this.slider_product > 0) {
        let data_product = discount[this.slider_product - 1];

        if (data_product !== undefined) {
          data = data_product.discount;
        }
      } else {
        data = 0;
      }

      return data;
    },
  },
};
</script>

<style>
.img-fluid {
  max-width: 100%;
  height: auto;
}
.h3-price {
  font-size: 2.7vh;
  font-weight: 500;
}
.divider-vertical-col {
  border-left: 1px solid #ccc;
}
.bg-green {
  color: #04b29b;
}

.bg-yellow {
  color: #f09804;
}
.bg-blue {
  color: #184199;
}
.bg-red {
  color: #c72b27;
}
.bg-pink {
  color: #d81b60;
}
</style>

<!-- function htmlDecode(input){
  var e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

htmlDecode("<\/code> ok,no.<\/p>"); 
// returns "<img src='myimage.jpg'>" -->
